// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDropTextContainer(props) {
  return React.createElement("div", {
              className: "inline-block min-w-[100px]"
            }, React.createElement(V3DndBehaviour$LiteracyplanetTupperware.DropNoChildren.make, {
                  id: props.id,
                  containerClassname: "PilotClozeDropSingletContainer-containerClassname min-w-[100px] bg-[#f2f6f8] mb-2 flex justify-center",
                  containerOverClassname: "PilotClozeDropSingletContainer-containerOverClassname min-w-[100px] bg-[#d2dcf0] mb-2 flex justify-center",
                  dom: "span",
                  elementRef: "div"
                }));
}

var make = PilotClozeDropTextContainer;

var $$default = PilotClozeDropTextContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
